import {createCookie} from 'ubs-framework/v2/common/function';
import {constant} from "../../common/constant";
import {planMerger} from 'ubs-framework/v2/common/function';
import { getElectronProductAccess, isElectron } from 'ubs-framework/v2/common/function';

const initialState = {
    socketId: '',
    token: '',
    email: '',
    S3_BASE_URL: '',
    isAuthenticated: false,
    errorObject: {},
    isAdmin: false,
    logInDetails: {},
    forgotRecoveryUser: '',
    registerDetail: {},
    orgId:"",
    currentOrg: {},
    openSidebar: false,
    isSampleData: null,
    pendingPayment: null,
    paymentMethodInfo: null,
    orgList: [],
    isPreparingData: false,
    isSetupDone: { flag: false, isLoading: false },
    isInactiveRestricted : false,
    // Wallet Billing (Phase 8) — resolved once via billing|wallet|client|gate; null = not yet resolved
    // (route/nav treat null as "don't block yet" so legit users never see a false-404 flash).
    walletBillingGate: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION':
            return {...state, socketId: action.payload}
        case 'ON_BOARDING_AUTHENTICATE': {
            const data = {}
            if (action.payload) {
                data.S3_BASE_URL = action.payload.S3_BASEURL
            }
            return {...state,...data,...action.payload};
        }
        case 'LOGIN':
            let electronProductAccess = [];
            const planAccess = planMerger(action.payload?.planAccess, action.payload?.productAccess, action.payload?.isAdmin)
            if (![2, 3]?.includes(action.payload.signUpStep)) createCookie('ubs_token', action.payload.token, constant.COOKIE_DAYS)
            else createCookie('signup_token', action.payload.token, constant.COOKIE_DAYS)
            if (isElectron()) {
                electronProductAccess = (getElectronProductAccess(planAccess, action?.payload?.appType ?? undefined))?.includes('chat') ? 'superChat' : 'superTrack'
            }
            return {...state, ...action.payload, planAccess, electronProductAccess};
        case 'SET_LOG_IN_DETAILS':
            return {...state, logInDetails: action.payload};
        case 'SET_FORGOT_RECOVERY_USER':
            return {...state, forgotRecoveryUser: action.payload};
        case 'AUTHENTICATE': {
            const data = {isAuthenticated: !!action.payload, authData: action?.payload}
            if (action.payload) {
                data.S3_BASE_URL = action.payload.S3_BASEURL
                data.isInactiveRestricted = action?.payload?.isInactiveRestricted === true
                if (action.payload.planInfo) {
                    data.planInfo = { ...action?.payload?.planInfo, isTrialAccount: action?.payload?.isTrialAccount }
                }
            }
            return {...state,...data}

        }
        case 'SET_EMAIL':
            return {...state, email: action.payload};
        case 'SET_IS_ADMIN':
            return {...state, isAdmin: action.payload};
        case 'ERROR':
            return {...state, errorObject: action.payload}
        case 'SET_ERROR': {
            return {...state, error: action.payload}
        }
        case 'LOGOUT':
            return {
                token: '',
                email: '',
                isAuthenticated: false,
                errorObject: {},
            }
        case 'SET_REGISTER_DETAIL':
            return {...state, registerDetail: {...state.registerDetail, ...action.payload}};
        case 'SET_CURRENT_ORG':
            return {...state, currentOrg: action.payload, orgId: action?.payload?.orgId};
        case 'OPEN_SIDEBAR': {
            return {...state, openSidebar: action.payload};
        }
        case 'SET_PENDING_PAYMENT':
            return { ...state, pendingPayment: action?.payload }
        case 'SET_PAYMENT_METHOD_INFO':
            return { ...state, paymentMethodInfo: action?.payload }
        case 'SET_ORG_LIST':
            return { ...state, orgList: action.payload }
        case 'SET_SAMPLE_DATA': {
            return { ...state, isSampleData: action?.payload }
        }
        case 'SET_PREPARING_DATA': {
            return { ...state, isPreparingData: action?.payload }
        }
        case 'SET_SETUP_DONE': {
            return { ...state, isSetupDone: action?.payload }
        }
        case 'SET_WALLET_BILLING_GATE': {
            return { ...state, walletBillingGate: action?.payload }
        }
        default:
            return state;
    }
}
